import { AxiosResponse } from 'axios';
import { apiWrapper, axiosApi } from 'utils/api';
import { Pagination } from 'utils/table';

export const getOperationLog = async (
  $skip?: number,
  $limit?: number,
  target?: string,
): Promise<AxiosResponse<Pagination> | void> => {
  const success = async (): Promise<AxiosResponse<Pagination>> => {
    const response = await axiosApi().get<Pagination>(`/operation-log`, {
      params: { page: $skip, pageSize: $limit, target },
    });
    return {
      ...response,
    };
  };

  return apiWrapper<Pagination>({
    success,
  });
};

export const apiSiteListAll = async (tenantId?: string): Promise<any> => {
  const success = async (): Promise<any> => {
    const response = await axiosApi().get(`/sites/all`, {
      params: {
        tenantId,
      },
    });
    return {
      ...response,
    };
  };

  return apiWrapper<Pagination>({
    success,
  });
};

export const apiChooseSite = async (
  siteId: string,
  options?: any,
): Promise<any> => {
  const success = async (): Promise<any> => {
    const res = await axiosApi(options).post(`/choose-site`, { siteId });
    return res;
  };

  return apiWrapper<Pagination>({
    success,
  });
};

export const getSiteList = async (
  $skip?: number,
  $limit?: number,
  studiesId?: string,
): Promise<AxiosResponse<Pagination> | void> => {
  const success = async (): Promise<AxiosResponse<Pagination>> => {
    const response = await axiosApi().get<Pagination>(`/sites`, {
      params: {
        studiesId,
        page: $skip || 1,
        pageSize: $limit,
      },
    });
    return {
      ...response,
    };
  };

  return apiWrapper<Pagination>({
    success,
  });
};

export const addSite = async (
  data: any,
): Promise<AxiosResponse<any> | void> => {
  const success = async (): Promise<AxiosResponse> =>
    axiosApi().post<any>(`/sites`, data);

  return apiWrapper<any>({
    success,
  });
};

export const editSite = async (
  id: any,
  data: any,
): Promise<AxiosResponse<any> | void> => {
  const success = async (): Promise<AxiosResponse> =>
    axiosApi().patch<any>(`/sites/${id}`, data);

  return apiWrapper<any>({
    success,
  });
};
